import { PermissionNameEnum } from '@Types/permissions';
import Quarantine from '.';
import RiskAiDetection from './RiskAI/DetectionDetails';
import { AnalysisRemediationDetails } from './UserReportedEmails/AnalysisRemediationDetails';

const quarantineRouter = [
  {
    path: '/quarantine/*',
    element: Quarantine,
    name: 'side.group.operations',
    permission: [
      PermissionNameEnum.quarantine,
      PermissionNameEnum.administrator,
    ],
  },
  {
    path: '/quarantine/correlated-intelligence/:detectionId',
    element: RiskAiDetection,
    name: 'side.group.operations',
    permission: [
      PermissionNameEnum.quarantine,
      PermissionNameEnum.administrator,
    ],
  },
  {
    path: '/quarantine/euq-feedback/:companyGuid/:feedbackId',
    element: AnalysisRemediationDetails,
    name: 'side.group.operations',
    permission: [
      PermissionNameEnum.quarantine,
      PermissionNameEnum.administrator,
    ],
  },
];

export default quarantineRouter;
